import { useQuery } from '@tanstack/react-query';
import { IS_ENTERPRISE, IS_SELF_HOSTED } from '@/config';
import { useEnvironment } from '@/context/environment/hooks';
import { QueryKeys } from '@/utils/query-keys';
import { GetOrganizationSettingsDto, getOrganizationSettings } from '../api/organization';

export const useFetchOrganizationSettings = () => {
  const { currentEnvironment } = useEnvironment();

  const query = useQuery<{ data: GetOrganizationSettingsDto }>({
    queryKey: [QueryKeys.organizationSettings, currentEnvironment?._id],
    queryFn: async () => await getOrganizationSettings({ environment: currentEnvironment! }),
    // Enterprise self-hosted exposes /v1/organizations/settings (e.g. removeNovuBranding), so the
    // read must be enabled there too — otherwise the setting persists via PATCH but the UI never
    // reflects it on reload. Mirrors the gating used by useFetchSubscription.
    enabled: !!currentEnvironment?._id && (IS_ENTERPRISE || !IS_SELF_HOSTED),
    refetchOnMount: false,
  });

  return query;
};
